import axios from "axios";

export const fetchGetParentCompany = (id: string) => {
  return axios.get(`/api/parentcompany/${id}`);
};
